module.exports = __webpack_public_path__ + "static/ratehub-04147db004bfe18577fbe13e1cf1f317.png";